export default __webpack_public_path__ + "./fonts/left-arrow.39fff725.svg";